// ============================================
// UPDATED HOLIDAY SERVICE (holiday.service.ts)
// ============================================
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

// Updated interface based on API
export interface CreateHolidayDto {
  DateOnly?: string; // Format: YYYY-MM-DD
  Name: string;
  Type: HolidayType;
  IsRecurring: boolean;
  Date:string;
}

export interface PublicHoliday {
  id?: string; // Changed from number to string
  dateOnly?: string; // Changed from date to dateOnly
  date?: string; // Added date field
  name: string;
  type: HolidayType;
  isRecurring: boolean;
  isActive?: boolean;
  // Removed fields not in the API
}

export enum HolidayType {
  Public = 0,
  Mandatory = 1
}

export interface MandatoryLeave {
  id?: string;
  name: string;
  startDate: Date | string;
  endDate: Date | string;
  description?: string;
  leaveType: number;
  appliesTo: 'all' | 'department' | 'specific';
  departmentIds?: number[];
  employeeIds?: string[];
  isActive: boolean;
  createdOn?: Date;
  createdBy?: string;
  modifiedOn?: Date;
  modifiedBy?: string;
}

@Injectable({
  providedIn: 'root'
})
export class HolidayService {
  private apiUrl = environment.apiConfig.corporateAPI.endpoint+ '/api';
  private companyId: string = ''; // This should be set from your auth/company service

  constructor(private http: HttpClient) {
    // Get company ID from your auth service or storage
    this.companyId = this.getCompanyId();
  }

  private getCompanyId(): string {
    // Implement this based on how you store company information
    // For example, from localStorage or a service
    return localStorage.getItem('companyId') || '';
  }

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('auth_token');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }

  getPublicHolidays(year: number): Observable<PublicHoliday[]> {
    return this.http.get<PublicHoliday[]>(`${this.apiUrl}/holidays/public`, { params: { year: year.toString() } }).pipe(
      catchError(() => of([]))
    );
  }

  getHolidaysBetweenDates(startDate: Date, endDate: Date): Observable<PublicHoliday[]> {
    return this.http.get<PublicHoliday[]>(`${this.apiUrl}/holidays`, {
      params: {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString()
      }
    }).pipe(
      catchError(() => of([]))
    );
  }

  getActiveMandatoryLeaves(): Observable<MandatoryLeave[]> {
    return this.http.get<MandatoryLeave[]>(`${this.apiUrl}/holidays/mandatory/active`).pipe(
      catchError(() => of([]))
    );
  }

}